import React from "react";
import {
  Drawer,
  Typography,
  Flex,
  Tag,
  Descriptions,
  Button,
} from "antd";
import { daysInStage, PIPELINE_STAGES } from "./pipelineData";
import { formatDisplayDate } from "../../../utils/formatters";

const { Title, Text, Paragraph } = Typography;

const getPriorityColor = (priority) => {
  if (priority === "High") return "red";
  if (priority === "Medium") return "orange";
  return "green";
};

function DealDetailsDrawer({ visible, onClose, deal, onOpenMoveModal }) {
  if (!deal) return null;

  const currentStage = PIPELINE_STAGES.find((s) => s.code === deal.pipelineStage);

  return (
    <Drawer
      open={visible}
      onClose={onClose}
      width={460}
      title={
        <Flex vertical>
          <Text type="secondary" style={{ fontSize: "0.75rem", textTransform: "uppercase", fontWeight: 700 }}>
            Deal Overview
          </Text>
          <Title level={4} style={{ margin: 0 }}>
            {deal.leadCompanyName}
          </Title>
        </Flex>
      }
      extra={
        <Button
          type="primary"
          size="small"
          onClick={() => {
            onClose();
            onOpenMoveModal(deal);
          }}
        >
          Move Stage
        </Button>
      }
    >
      <Flex vertical gap={20}>
        <Flex justify="space-between" align="center" style={{ background: "#f8fafc", padding: "12px 16px", borderRadius: 10 }}>
          <Flex vertical>
            <Text type="secondary" style={{ fontSize: "0.75rem" }}>Current Stage</Text>
            <Text strong style={{ fontSize: "0.95rem", color: "#0f172a" }}>
              {currentStage?.name || deal.pipelineStage}
            </Text>
          </Flex>
          <Flex vertical align="flex-end">
            <Text type="secondary" style={{ fontSize: "0.75rem" }}>Time in Stage</Text>
            <Tag color="blue">{daysInStage(deal.stageChangedAt)} days</Tag>
          </Flex>
        </Flex>

        <Descriptions column={1} bordered size="small">
          <Descriptions.Item label="Deal Name">{deal.dealName}</Descriptions.Item>
          <Descriptions.Item label="Estimated Value">
            <Text strong style={{ color: "#10b981" }}>
              ₹{deal.amount?.toLocaleString("en-IN") || "0"}
            </Text>
          </Descriptions.Item>
          <Descriptions.Item label="Contact Person">{deal.contactName}</Descriptions.Item>
          <Descriptions.Item label="Contact Phone">{deal.contactNumber || "—"}</Descriptions.Item>
          <Descriptions.Item label="Assigned Sales Rep">{deal.assignedEmployeeName || "Unassigned"}</Descriptions.Item>
          <Descriptions.Item label="Expected Closing Date">{formatDisplayDate(deal.closingDate)}</Descriptions.Item>
          <Descriptions.Item label="Priority">
            <Tag color={getPriorityColor(deal.priority)}>
              {deal.priority}
            </Tag>
          </Descriptions.Item>
        </Descriptions>

        {deal.customerNeed && (
          <div>
            <Text strong style={{ fontSize: "0.85rem", display: "block", marginBottom: 4 }}>Customer Need:</Text>
            <Paragraph style={{ background: "#f8fafc", padding: 10, borderRadius: 8, fontSize: "0.82rem", color: "#475569" }}>
              {deal.customerNeed}
            </Paragraph>
          </div>
        )}

        {deal.painPoint && (
          <div>
            <Text strong style={{ fontSize: "0.85rem", display: "block", marginBottom: 4 }}>Pain Points:</Text>
            <Paragraph style={{ background: "#f8fafc", padding: 10, borderRadius: 8, fontSize: "0.82rem", color: "#475569" }}>
              {deal.painPoint}
            </Paragraph>
          </div>
        )}

        {deal.wonNotes && (
          <div>
            <Text strong style={{ fontSize: "0.85rem", color: "#10b981", display: "block", marginBottom: 4 }}>Won Success Notes:</Text>
            <Paragraph style={{ background: "#f0fdf4", padding: 10, borderRadius: 8, fontSize: "0.82rem", color: "#166534" }}>
              {deal.wonNotes}
            </Paragraph>
          </div>
        )}

        {deal.lostReason && (
          <div>
            <Text strong style={{ fontSize: "0.85rem", color: "#ef4444", display: "block", marginBottom: 4 }}>Loss Analysis:</Text>
            <Paragraph style={{ background: "#fef2f2", padding: 10, borderRadius: 8, fontSize: "0.82rem", color: "#991b1b" }}>
              Reason: <b>{deal.lostReason}</b> {deal.lossNotes ? `— ${deal.lossNotes}` : ""}
            </Paragraph>
          </div>
        )}
      </Flex>
    </Drawer>
  );
}

export default DealDetailsDrawer;
